import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Form, Label, Button } from 'reactstrap';
import * as XLSX from 'xlsx';
import InputFile from '../../../components/InputFields/InputFile';
import Uploadform from "../../../assets/images/upload_tree.svg";
import "../PatientProfile.css";
import { DepartmentOptions, genderOptions, maritalOptions, medicaidOptions, validateRow, yesNoMedicaidOptions } from '../Constant';
import { toast } from 'react-toastify';
import { createBulkPatients, getPatientSchema } from '../../../api/patient';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../components/Loader/Loader';
import moment from 'moment';
import { failed, success } from "../../../utils/Tostify";
import patientSchema from "./patientSchema.json";

const ImportPatient = ({setShowImportModel,showImportModel,getPatientList}) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    let token = useSelector(state => state.userReducer.token);

    const handleCancel = () => {
      setShowImportModel(false);
      setSelectedFile(null);
    };

    const formik = useFormik({
        initialValues: {
          file: null
        },
    onSubmit: async (values) => {
      if (!values.file) return;
    }});

    const handleFileUpload = () => {
      if (!selectedFile) return;

      setIsLoading(true);

      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        const headers = jsonData[0];
        const emailFieldIndex = headers.indexOf("email");
        const emailSet = new Set();

        const rows = jsonData.slice(1).map((row) => {
          const rowData = {};
          headers.forEach((header, index) => {
            let value = row[index];
            if ((header === 'dob' || header === 'doa') && !isNaN(value)) {
              // Convert Excel serial date number to JavaScript Date
              const excelDate = new Date((value - 25569) * 86400 * 1000); // Adjust for Excel's start date
              value = moment(excelDate).format("MM-DD-YYYY"); // Format to MM-DD-YYYY
            }
            rowData[header] = value;
          });
          rowData.orgId = localStorage.getItem("currentOrgId");
          rowData.clinicId = localStorage.getItem("currentHospitalId");
          return rowData;
        });

        // Validate each row
        const invalidRows = [];
        rows.forEach((row, index) => {
          const errors = validateRow(row, emailSet, emailFieldIndex);
          if (errors.length > 0) {
            invalidRows.push({ row: index + 2, errors });  // index + 2 to account for header row
          }
        });

        if (invalidRows.length > 0) {
          console.error("Validation Errors:", invalidRows);
          toast(
            `Validation failed in rows: ${invalidRows
              .map((r) => `Row ${r.row}: ${r.errors.join(", ")}`)
              .join("; ")}`
          );
          setIsLoading(false);
          return;
        }
        let res;

        try {
          const updatedRows = rows.map(row => ({
            ...row,
            departmentAprvlStatus: "New Patient",
            houseHoldSize : "1"
          }));

          const payload = {
            patients: updatedRows
          };
          res = await createBulkPatients({ values: payload, dispatch, token });
          if (res?.status == "SUCCESS") {
            getPatientList();
            setShowImportModel(false);
            success(res?.message);
          }else {
            setIsLoading(false);
            failed(res?.message);
          }
        } catch (error) {
          console.log('error----',error);
          console.error('Error sending data:', error);
        } finally {
          setIsLoading(false);
        }
      };

      reader.readAsArrayBuffer(selectedFile);
    };

  const downloadSampleFile = () => {
    const headers = ['name','email','gender','dob','mrnNumber','coverage','homePhone','address','state','postalCode','city','maritalStatus','socialSecurityNumber','doa','isDisable','isPregnant','isUsCitizen','isVeterian'];
    const worksheet = XLSX.utils.aoa_to_sheet([headers]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");
    XLSX.writeFile(workbook, "Patient_Sample.xlsx");
  };

  // const downloadSampleJsonFile = () => {
  //   // Data that you want to include in the JSON file
  // const data = patientSchema;

  // const jsonData = JSON.stringify(data, null, 2);
  // const blob = new Blob([jsonData], { type: 'application/json' });
  // const link = document.createElement('a');
  // link.href = URL.createObjectURL(blob);
  // link.download = 'Patient_Sample.json';
  // link.click();
  // };

  const downloadSampleJsonFile = async () => {
    try {
      const response = await getPatientSchema({ dispatch, token });

      // If you're using a custom API utility, you might not get `.ok`, so directly check for `response.data`
      if (!response || !response.data) {
        throw new Error('Failed to fetch schema');
      }

      const jsonData = JSON.stringify(response.data, null, 2); // this is the actual schema data
      const blob = new Blob([jsonData], { type: 'application/json' });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'Patient_Sample.json';
      document.body.appendChild(link); // for Firefox
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading sample JSON:', error);
    }
  };

  return (
    <div>
      <Modal
        isOpen={showImportModel}
        toggle={handleCancel}
        size="lg"
        className="upload_document_modal"
      >
        <Form onSubmit={formik.handleSubmit}>
          <ModalHeader toggle={handleCancel} className="assign_blk p-0 m-0">
            Upload Document
          </ModalHeader>
          <ModalBody className="m-0">
            {isLoading && <Loader/>}
              <div className="mx-0 upload_modall">
                <Label for="exampleFile" className="up_blk">
                  Upload
                </Label>
                <InputFile
                  keyField={"pdfForm"}
                  id="exampleFile"
                  name="file"
                  type="file"
                  accept=".csv,.xlsx"
                  multiple={false}
                  inputFile="file"
                  formik={formik}
                  setFile={(file) => {
                    formik.setFieldValue("file", file);
                    setSelectedFile(file);
                  }}
                  imageUrl={selectedFile}
                />
              </div>
          </ModalBody>
          <div className='d-flex justify-content-center flex-wrap gap-2'>
                <button
                type="button"
                className="save_btn mx-2"
                onClick={downloadSampleFile}
              >
                Download Sample Excel File
              </button>
              <button
                type="button"
                className="save_btn"
                onClick={downloadSampleJsonFile}
              >
                Download Sample JSON
              </button>
            </div>
          <div className="d-flex justify-content-center gap-3 mt-2 mb-2">
            <button className="save_btn" type="button" onClick={handleCancel}>
              Cancel
            </button>
            <button
              className="save_btn saving"
              type="button"
              onClick={handleFileUpload}
              disabled={!selectedFile || isLoading}
            >
              {isLoading ? "Saving..." : "Save"}
            </button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default ImportPatient;
